export { ImageFloatingLabel } from './ImageFloatingLabel';
